/* RESPONSIBLE TEAM: team-tickets-1 */
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { EntityType } from 'embercom/models/data/entity-types';
import AdminSummary, { type AdminSummaryWireFormat } from 'embercom/objects/inbox/admin-summary';
import TagSummary, { type TagSummaryWireFormat } from 'embercom/objects/inbox/tag-summary';

interface ConversationTagsUpdatedWireFormat {
  renderable_type: RenderableType;
  tagging_entity: AdminSummaryWireFormat;
  tags_added: TagSummaryWireFormat[];
  tags_removed: TagSummaryWireFormat[];
}

export default class ConversationTagsUpdated implements RenderableData {
  readonly renderableType = RenderableType.ConversationTagsUpdated;
  readonly tagsAdded: TagSummary[] = [];
  readonly tagsRemoved: TagSummary[] = [];
  readonly taggingEntity: AdminSummary;

  constructor(taggingEntity: AdminSummary, tagsAdded: TagSummary[], tagsRemoved: TagSummary[]) {
    this.tagsAdded = tagsAdded;
    this.tagsRemoved = tagsRemoved;
    this.taggingEntity = taggingEntity;
  }

  get creatingEntity() {
    return {
      type: EntityType.Admin,
      id: this.taggingEntity.id,
      object: this.taggingEntity,
    };
  }

  get adminOnly() {
    return true;
  }

  get styles() {
    return {
      backgroundColor: 'bg-beta-container',
      textColor: 'text-default',
      backgroundColorHover: 'bg-beta-container-emphasis',
    };
  }

  static deserialize(json: ConversationTagsUpdatedWireFormat): ConversationTagsUpdated {
    let taggingEntity = AdminSummary.deserialize(json.tagging_entity);
    let tagsAdded = (json.tags_added || []).map(TagSummary.deserialize);
    let tagsRemoved = (json.tags_removed || []).map(TagSummary.deserialize);

    return new ConversationTagsUpdated(taggingEntity, tagsAdded, tagsRemoved);
  }
}
